import { DataType } from '@/util/index'

const BANK_RECORDS = {
  section: {
    name: 'statement',
    caption: 'BANK RECORDS',
    type: 'table',
    fieldKey: 'statement',
    code: DataType.PrivilegeCode.BANK_RECORDS_SECTION
  },
  dialogWidth: '1300px',
  sectionFields: [
    { label: 'VOB', template: '{vob}', fieldKey: 'vob', controlType: 'v-select', options: { vob: DataType.VoB } },
    { label: 'Date', template: '{payrollDate}', fieldKey: 'payrollDate', controlType: 'v-date-picker' },
    { label: 'Payroll Type', template: '{payrollType}', fieldKey: 'payrollType', controlType: 'v-select', options: { payrollType: DataType.PayrollType } },
    { label: 'Amount', template: '{amount}', fieldKey: 'amount', format: 'currency' },
    { label: 'Balance', template: '{balance}', fieldKey: 'balance', format: 'currency' }
  ],
  formFields: [
    { label: 'VOB', template: '{vob}', fieldKey: 'vob', controlType: 'v-select', options: { vob: DataType.VoB } },
    { label: 'Date', template: '{payrollDate}', fieldKey: 'payrollDate', format: 'date', controlType: 'v-date-picker', disabled: true, allowed: 'no-weekend,end-now' },
    { label: 'Payroll Type', template: '{payrollType}', fieldKey: 'payrollType', controlType: 'v-select', options: { payrollType: DataType.PayrollType } },
    { label: 'Amount', template: '{amount}', fieldKey: 'amount', format: 'currency' },
    { label: 'Balance', template: '{balance}', fieldKey: 'balance', format: 'currency' }
  ],
  headers: [
    { text: '#', sortable: false },
    { text: 'VOB', value: 'vob', sortable: false },
    { text: 'Date', value: 'payrollDate', sortable: false },
    { text: 'Payroll Type', value: 'payrollType', sortable: false },
    { text: 'Amount', value: 'amount', sortable: false },
    { text: 'Balance', value: 'balance', sortable: false },
    { text: 'ACTION', sortable: false }
  ]
}
export default BANK_RECORDS
